import React from "react";
import { useEnsuredUser } from "../../common/contexts";
import { useGet, usePost } from "../../common/hooks";
import { Divider } from "antd";
import { GoalieAvailabilities, Game } from "../../common/interfaces";
import { AttendanceTable } from "../../common/components/AttendanceTable";
import Spinner from "../../common/components/Spinner";

export function Availability() {
  const user = useEnsuredUser();

  const availabilitiesStruct = useGet<GoalieAvailabilities>(
    `/api/goalieAvailabilities?goalieId=${user.goalieId}`
  );
  const availabilityPostReq = usePost({
    uri: "/api/updateGoalieAvailability",
    deps: [availabilitiesStruct]
  });

  if (availabilitiesStruct.data === undefined) {
    return <Spinner size={"large"} />;
  }

  const availabilities = availabilitiesStruct.data ? availabilitiesStruct.data.games : undefined;

  const onAvailabilityClick = (row: Game, modifyType: string) => {
    availabilityPostReq.send({
      gameId: row.id,
      goalieId: user.goalieId,
      available: modifyType === "add"
    });
  };

  return (
    <>
      <Divider>Goalie Availability</Divider>
      <AttendanceTable
        games={availabilities}
        isLoading={availabilityPostReq.isLoading || availabilitiesStruct.isLoading}
        showAttendanceButtons={true}
        onClick={onAvailabilityClick}
        attendanceColLabel={"Available"}

      />
    </>
  );
}
